import React, { useState } from "react";
import PropTypes from "prop-types";
import { Collapse } from "reactstrap";
import _ from "lodash";
import SchoolFilter from "../../filters/components/school-filter";
import SportsFilter from "../../filters/components/sports-filter";
import CategoriesFilter from "../../filters/components/categories-filter";
import EventTypeFilter from "../../filters/components/event-type-filter";
import TabFilterContext from "../../../contexts/tabFilter";
import SearchFilter from "./search";
import { EVENT_TYPES } from "../../../constants";

const propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  activeTab: PropTypes.string.isRequired,
  schools: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      clientName: PropTypes.string
    })
  ).isRequired,
  filters: PropTypes.shape({
    clientId: PropTypes.number,
    sport: PropTypes.number,
    tabName: PropTypes.string,
    showEventTypeFilter: PropTypes.bool
  }).isRequired,
  conferences: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      clientName: PropTypes.string
    })
  ).isRequired,
  conferenceId: PropTypes.number,
  onSelectConference: PropTypes.func.isRequired,
  onSelectSchool: PropTypes.func.isRequired,
  onSelectSport: PropTypes.func.isRequired,
  onEventTypeFilter: PropTypes.func.isRequired,
  onSelectCategory: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  sportTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      sport: PropTypes.number
    })
  ).isRequired,
  isOrg: PropTypes.bool.isRequired,
  hideSchoolFilter: PropTypes.bool.isRequired,
  showSportsFilter: PropTypes.bool.isRequired,
  showMembersFilter: PropTypes.bool.isRequired,
  showConferenceFilter: PropTypes.bool.isRequired,
  showCategoryFilter: PropTypes.bool.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired
};

const defaultProps = {
  conferenceId: null
};

function TabFilters(props) {
  const {
    isExpanded,
    activeTab,
    schools,
    filters,
    conferences,
    onSelectConference,
    onSelectSchool,
    onSelectSport,
    onSelectCategory,
    id,
    conferenceId,
    sportTypes,
    isOrg,
    hideSchoolFilter,
    onEventTypeFilter,
    showSportsFilter,
    showMembersFilter,
    showConferenceFilter,
    showCategoryFilter,
    categories
  } = props;

  const [section, setSection] = useState("");

  const toggleSection = (sectionSelected) => setSection(sectionSelected);

  let categoriesList = [];
  // 48px of navigation bar plus 48 of Search Filter
  // We do this because using 100vh doesn't get along with all devices
  let maxHeight = 96;
  if (isOrg && showConferenceFilter) maxHeight += 42;
  if (!hideSchoolFilter && showMembersFilter) maxHeight += 42;
  if (showSportsFilter) maxHeight += 42;
  if (filters.showEventTypeFilter) maxHeight += 42;
  if (!_.isEmpty(categories) && showCategoryFilter) {
    categoriesList = [
      { value: 0, text: "All Categories" },
      ..._.orderBy(
        categories.map((type) => ({
          value: type.id,
          text: type.name
        })),
        "text",
        "asc"
      )
    ];
    maxHeight += 42;
  }

  /* eslint-disable react/jsx-no-constructed-context-values */
  return (
    <TabFilterContext.Provider
      value={{
        section,
        maxHeight,
        toggleSection
      }}
    >
      <Collapse className="sub-filter" isOpen={isExpanded}>
        <SearchFilter />
        {filters.showEventTypeFilter && (
          <EventTypeFilter
            types={EVENT_TYPES}
            filters={filters}
            handleClick={onEventTypeFilter}
            tabName={activeTab}
          />
        )}
        {isOrg && showConferenceFilter && (
          <SchoolFilter
            siblings={conferences}
            filters={filters}
            clientId={conferenceId}
            forConference
            handleClick={onSelectConference}
            tabName={activeTab}
            placeHolderText="All Conferences"
          />
        )}
        {!hideSchoolFilter && showMembersFilter && (
          <SchoolFilter
            siblings={schools}
            filters={filters}
            clientId={id}
            handleClick={onSelectSchool}
            tabName={activeTab}
          />
        )}
        {showSportsFilter && (
          <SportsFilter
            types={sportTypes}
            filters={filters}
            handleClick={onSelectSport}
            tabName={activeTab}
          />
        )}
        {!_.isEmpty(categoriesList) && (
          <CategoriesFilter
            categories={categoriesList}
            filters={filters}
            handleClick={onSelectCategory}
            tabName={activeTab}
          />
        )}
      </Collapse>
    </TabFilterContext.Provider>
  );
  /* eslint-disable react/jsx-no-constructed-context-values */
}

TabFilters.propTypes = propTypes;
TabFilters.defaultProps = defaultProps;

export default TabFilters;
